import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { backendApiUrl, notificationUrl, vAssistUrl } from '../../api/config';
import { pushProfileData } from '../../utils/cleverTap';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import { makeRequest } from '../../api/api';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import axios from 'axios';
import { epochCurrentTime } from '../../utils/utilityFunction';
import {
  extractProgramIdFromUrl,
  generateRandomTextRegex
} from '../../constant/constant';
import { programRoutes } from '../../config/routes';

const programDetailsBaseUrl = `${backendApiUrl}?`;

export const getProgramData = createAsyncThunk(
  'program/getData',
  async (token) => {
    try {
      let programDetailsParams = {
        moodlewsrestformat: 'json',
        wstoken: token,
        wsfunction: 'block_programs_get_user_learningplans_details',
        type: 'web'
      };

      let programDetailsUrl =
        programDetailsBaseUrl + new URLSearchParams(programDetailsParams);
      // console.log("program details url", programDetailsUrl);

      let response = await fetch(programDetailsUrl);
      // console.log("program details response", response);

      if (response.ok) {
        let data = await response.json();
        // console.log("program details data", data);
        if (data.program) {
          return data.program;
        } else if (data?.exception == 'invalid_response_exception') {
          throw new Error('data unavailable');
        } else {
          throw new Error('something went wrong');
        }
      } else {
        throw new Error('sevice not available');
      }
    } catch (err) {
      // console.log("get program details error", err);
      throw err;
    }
  }
);

export const getNotification = createAsyncThunk(
  'program/getNotification',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_ALL_NOTIFICATION,
          wstoken: thunkApi.getState().auth.token,
          useridto: 0
        }
      );
      if (response?.data?.errorcode == 'forcepasswordchangenotice') {
        thunkApi.dispatch(resetForcedPassword({}));
      }

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const resetForcedPassword = createAsyncThunk(
  'program/resetForcedPassword',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.FORCED_PASSWORD_RESET,
          password: generateRandomTextRegex(15),
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const markAllAsRead = createAsyncThunk(
  'program/markAllAsRead',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.MARK_ALL_READ,
          useridto: thunkApi.getState().auth.userData.userid,
          wstoken: thunkApi.getState().auth.token
        }
      );
      const res = await axios.put(
        `${notificationUrl}/event-manager/events/v1/updateall`,
        null,
        {
          params: {
            email:
              thunkApi.getState().user.profileData?.leanerApiData
                ?.emailAddress || thunkApi.getState().auth.userData.email
          }
        }
      );

      thunkApi.dispatch(getNotification());

      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const markSingleRead = createAsyncThunk(
  'program/markSingleRead',
  async (param, thunkApi) => {
    try {
      let response = {};
      if (param?.type == 'clevertap') {
        response = await axios.put(
          `${notificationUrl}/event-manager/events/v1/update`,
          null, // No request body
          {
            params: {
              id: param.notificationid,
              read: true
            }
          }
        );
      } else {
        const check = { ...param };
        delete check.url;
        delete check.type;
        response = await makeRequest(SERVICES.MOODLE_SERVICE, '', METHODS.GET, {
          ...check,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.POST_NEW_FEATURE_READ_NOTIFICATION,
          timeread: epochCurrentTime(),
          wstoken: thunkApi.getState().auth.token,
          notificationid: param.notificationid
        });
      }
      thunkApi.dispatch(getNotification());
      // window.open(
      //   `${param.url}&token=${btoa(thunkApi.getState().auth.token)}`,
      //   '_blank'
      // );
      // if (response.data) {
      // thunkApi.dispatch(getNotification());
      // }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

const initialState = {
  isLoading: false,
  responseReceived: false,
  programData: null,
  currentProgram: {
    lpid: null,
    lpname: ''
  },
  error: null,
  firstProgramId: null,
  notificationLoading: false,
  isForcedPaawordResetLoading: false,
  notificationData: []
};
const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    setCurrentProgram: (state, action) => {
      state.currentProgram = state?.programData
        ? state.programData[action.payload]
        : null;
    },
    resetActivityErrorState: (state, action) => {
      Object.keys(action.payload).map((val) => {
        state[val] = action.payload[val];
      });
    }
  },
  extraReducers: {
    [getProgramData.fulfilled]: (state, action) => {
      state.isLoading = false;
      const { payload } = action;
      payload.sort((a, b) => new Date(b.startdate) - new Date(a.startdate));
      const cleverData = {};
      if (payload?.length) {
        cleverData[`Batch_Name_1`] = payload[0]?.lpname;
      }
      if (payload?.length > 1) {
        cleverData[`Batch_Name_2`] = payload[1]?.lpname;
      }
      if (payload?.length > 2) {
        cleverData[`Batch_Name_3`] = payload[2]?.lpname;
      }
      pushProfileData(cleverData);
      state.programData = payload;
      let index = 0;
      const currentProgram = extractProgramIdFromUrl(
        window.location.pathname,
        programRoutes
      );
      if (currentProgram) {
        index = payload.findIndex((obj) => obj.lpid == currentProgram);
      }
      state.currentProgram = payload[index < 0 ? 0 : index];
      state.firstProgramId = payload[index < 0 ? 0 : index]?.lpid;
    },
    [getProgramData.pending]: (state) => {
      state.isLoading = true;
    },
    [getProgramData.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    },
    [getNotification.pending]: (state) => {
      state.notificationLoading = true;
    },
    [getNotification.fulfilled]: (state, action) => {
      state.notificationLoading = false;
      const temp = action.payload;
      temp.unreadcount = action.payload?.notifications?.some(
        (notification) => notification?.read === false
      );
      state.notificationData = action.payload;
    },
    [getNotification.rejected]: (state, action) => {
      state.notificationLoading = false;
      state.notificationData = action.payload;
    },
    [resetForcedPassword.pending]: (state) => {
      state.isForcedPaawordResetLoading = true;
    },
    [resetForcedPassword.fulfilled]: (state, action) => {
      state.isForcedPaawordResetLoading = false;
      window.location.reload();
    },
    [resetForcedPassword.rejected]: (state, action) => {
      state.isForcedPaawordResetLoading = false;
    }
  }
});
export const { setCurrentProgram, setResponse, resetActivityErrorState } =
  programSlice.actions;
export default programSlice.reducer;
